export class ContributorsDto{
  id!: string;
  fullName!: string;
  isOwner: boolean = false;

  constructor(attributes: Partial<ContributorsDto> = {}) {
    Object.assign(this, attributes);
  }
}